/** Atalho "Meu passaporte · N lugares" — em Memórias e na Home (depois). */
import { featureEnabled } from '@nv/core';
import { Link } from 'react-router-dom';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { Ilustracao } from '../../ui/Ilustracao';
import { usePassaporte } from './api';

export function AtalhoDoPassaporte() {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'carimbos');
  const p = usePassaporte(tripId, ligado);
  if (!ligado) return null;
  const n = p.data?.places ?? 0;
  return (
    <Link to="/passaporte" className="card pass__atalho" data-testid="atalho-passaporte">
      <Ilustracao nome="passaporte" tamanho={48} />
      <span className="rk__linha-texto">
        <span className="rk__linha-nome">Meu passaporte</span>
        <span className="rk__linha-familia">{p.data ? (n === 0 ? 'nenhum carimbo ainda' : `${n} ${n === 1 ? 'lugar carimbado' : 'lugares carimbados'} em ${p.data.days} ${p.data.days === 1 ? 'dia' : 'dias'}`) : '…'}</span>
      </span>
      <Icon name="avancar" size={18} />
    </Link>
  );
}
